import { CommonModule } from "@angular/common";
import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { GENERIC_CATEGORY_LIST_TRANSLATE_BASE } from "@shared/constants/stored-documents.constants";
import { StoredDocumentCategory } from "@shared/models/stored-document-category.model";
import _ from "lodash";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { OverlayPanelModule } from "primeng/overlaypanel";

@Component({
  selector: "app-stored-documents-category-management",
  standalone: true,
  imports: [CommonModule, ButtonModule, CardModule, TranslateModule, OverlayPanelModule, InputTextModule, FormsModule],
  templateUrl: "./stored-documents-category-management.component.html",
  styleUrl: "./stored-documents-category-management.component.scss",
})
export class StoredDocumentsCategoryManagementComponent implements OnChanges {
  @Input() categories: StoredDocumentCategory[] | undefined;
  @Output() sendNewCategoryEvent = new EventEmitter<StoredDocumentCategory[]>();
  @Output() cancelNewCategoryEvent = new EventEmitter<boolean>();

  @ViewChild("newCategoryInput") newCategoryInput!: ElementRef;
  @ViewChild("editCategoryInput") editCategoryInput!: ElementRef;
  newCategoryName = "";
  editingIndex: number | null = null;
  addingNewCategory = false;
  workingCategories: StoredDocumentCategory[] = [];
  originalCategoryName = "";
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["categories"]) {
      this.workingCategories = _.cloneDeep(this.categories!);
    }
  }

  getGenericCategoryTranslationUri(id: string) {
    return GENERIC_CATEGORY_LIST_TRANSLATE_BASE + id;
  }

  startAddingCategory() {
    this.addingNewCategory = true;
    this.newCategoryName = "";
    setTimeout(() => {
      this.newCategoryInput.nativeElement.focus();
    }, 0);
  }

  addCategory() {
    if (this.newCategoryName.trim()) {
      const newCategory: StoredDocumentCategory = {
        id: 0,
        name: this.newCategoryName,
        isCustom: true,
        documentCount: 0,
      };
      this.workingCategories.push(newCategory);
    }
    this.addingNewCategory = false;
  }

  editCategory(index: number) {
    if (this.workingCategories[index].isCustom) {
      this.editingIndex = index;
      this.originalCategoryName = this.workingCategories[index].name;
      setTimeout(() => {
        if (this.editCategoryInput) {
          this.editCategoryInput.nativeElement.focus();
        }
      }, 0);
      if (this.workingCategories[index].id === 0) {
        this.startAddingCategory();
        this.newCategoryName = this.workingCategories[index].name;
        this.workingCategories.splice(index, 1);
      }
    }
  }

  deleteCustomCategory(categoryIndex: number) {
    this.workingCategories?.splice(categoryIndex, 1);
  }

  saveCategories() {
    this.sendNewCategoryEvent.emit(this.workingCategories);
  }

  saveCategory(index: number) {
    const name = this.workingCategories[index].name;
    if (!name.trim()) {
      this.workingCategories[index].name = this.originalCategoryName; // Restaurer l'ancien nom si le nouveau est vide
    } else if (name !== this.originalCategoryName) {
      this.workingCategories[index].name = name;
    }
    this.editingIndex = null;
  }

  cancelCategories() {
    this.cancelNewCategoryEvent.emit(true);
  }
}
